import AboutData from "../../data/elements/about.json";

const AboutFive = () => {
  return (
    <div className="row g-4 justify-content-center">
      {AboutData.aboutFive.map((founder, index) => (
        <div key={index} className="col-lg-5 col-md-8 col-12 d-flex">
          <div
            style={{
              background: "rgba(255,255,255,0.06)",
              border: "1px solid rgba(255,255,255,0.14)",
              borderRadius: "20px",
              overflow: "hidden",
              backdropFilter: "blur(8px)",
              transition: "transform 0.25s, box-shadow 0.25s",
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-6px)";
              e.currentTarget.style.boxShadow = "0 20px 50px rgba(0,0,0,0.35)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            {/* Founder photo */}
            <div style={{ position: "relative", width: "100%", height: "340px", flexShrink: 0, overflow: "hidden" }}>
              <img
                src={founder.authorImg}
                alt={founder.name}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "top center",
                  display: "block",
                  transition: "transform 0.4s ease",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              />
              {/* Gradient overlay */}
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: "50%",
                  background: "linear-gradient(to top, rgba(14,20,46,0.9) 0%, transparent 100%)",
                  pointerEvents: "none",
                }}
              />
              {/* Name over image */}
              <div style={{ position: "absolute", bottom: "20px", left: "24px", right: "24px" }}>
                <h4 style={{ color: "#fff", fontWeight: "800", marginBottom: "4px", fontSize: "22px" }}>
                  {founder.name}
                </h4>
                <span
                  style={{
                    background: "#DB6827",
                    color: "#fff",
                    fontSize: "12px",
                    fontWeight: "700",
                    padding: "3px 12px",
                    borderRadius: "100px",
                    letterSpacing: "0.5px",
                  }}
                >
                  {founder.title}
                </span>
              </div>
            </div>

            {/* Bio text */}
            <div style={{ padding: "24px 26px 28px", flex: "1 1 auto" }}>
              <p
                style={{
                  color: "rgba(255,255,255,0.75)",
                  fontSize: "14px",
                  lineHeight: "1.75",
                  marginBottom: 0,
                  textAlign: "justify",
                }}
              >
                {founder.info}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AboutFive;
